import { RBox } from '@/pages/__styled'
import colors from '@/styles/colors'
import { DMConnection, Topic } from '@/types'
import { formattedNumber, getDMTopicStates, getTopicStates } from '@/utils/helper'
import { Box, Typography } from '@mui/material'
import SVG from 'react-inlinesvg'

interface Props {
  topic: Topic | DMConnection
  type?: 'album' | 'dm'
}

export function TopicStates({ topic, type = 'album' }: Props) {
  if (topic as Topic) {
    return (
      <RBox gap={'12px'}>
        {getTopicStates(topic as Topic).map((item, index) => (
          <Box
            key={item.key}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 14px',
              borderRadius: '10px',
              backgroundColor: '#ffffff',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                backgroundColor: '#f8fafc',
                borderColor: '#cbd5e1',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              },
            }}
          >
            <SVG src={item.icon} width={item.width} height={item.height} color='#6366f1' />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#475569',
                letterSpacing: '-0.01em',
              }}
            >
              {formattedNumber(item.value)}
            </Typography>
          </Box>
        ))}
      </RBox>
    )
  } else {
    return (
      <>
        {getDMTopicStates((topic as DMConnection).topicStats).map((item) => (
          <Box
            key={item.key}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              borderRadius: '8px',
              backgroundColor: 'rgba(248, 250, 252, 0.8)',
              border: '1px solid rgba(226, 232, 240, 0.6)',
              marginRight: 1.5,
            }}
          >
            <SVG src={item.icon} width={14} height={14} color='#64748b' />
            <Typography
              sx={{ fontSize: '13px', fontWeight: 500, color: '#64748b', letterSpacing: '-0.01em' }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </>
    )
  }
}
